class IaSetInfo extends HTMLElement {
  constructor() {
    super();
    this.imageWrapper = this.querySelector('[data-set-info-image-wrapper]');
    this.infoBlocks = this.querySelectorAll('[data-set-info-block]');
    this.accordionsWrapper = this.querySelector('.ia-set-info__accordions');

    this.init();
  }

  init() {
    // Find the first expanded accordion block, or fall back to first block
    const expandedBlock = Array.from(this.infoBlocks).find((block) => {
      const accordion = block.querySelector('.ia-accordion--expanded');
      return accordion !== null;
    });

    const targetBlock = expandedBlock || this.infoBlocks[0];
    this.updateImage(targetBlock?.querySelector('[data-set-info-image]'));

    // Listen for clicks on info block headers
    this.infoBlocks.forEach((block) => {
      const header = block.querySelector('[data-toggle-accordion]');
      if (header) {
        header.addEventListener('click', () => {
          const imageTemplate = block.querySelector('[data-set-info-image]');
          this.updateImage(imageTemplate);
          this.scrollAccordionIntoView(block);
        });
      }
    });
  }

  updateImage(imageTemplate) {
    if (!this.imageWrapper || !imageTemplate) return;
    this.imageWrapper.innerHTML = imageTemplate.innerHTML;
  }

  scrollAccordionIntoView(accordionBlock) {
    if (!this.accordionsWrapper) return;

    // Wait for the accordion's expand transition to finish (~0.5s).
    setTimeout(() => {
      // Bail when the wrapper isn't scrollable (e.g. mobile, where height is unbounded).
      if (this.accordionsWrapper.scrollHeight <= this.accordionsWrapper.clientHeight) return;
      // Bail when the click collapsed the accordion.
      const accordion = accordionBlock.querySelector('.ia-accordion');
      if (!accordion?.classList.contains('ia-accordion--expanded')) return;

      const blockRect = accordionBlock.getBoundingClientRect();
      const wrapperRect = this.accordionsWrapper.getBoundingClientRect();
      const blockTallerThanWrapper = blockRect.height > wrapperRect.height;

      let delta = 0;
      if (blockRect.bottom > wrapperRect.bottom) {
        // Bottom hidden: align the top if the accordion is too tall to fit; otherwise
        // scroll just enough to reveal the bottom.
        delta = blockTallerThanWrapper
          ? blockRect.top - wrapperRect.top
          : blockRect.bottom - wrapperRect.bottom;
      } else if (blockRect.top < wrapperRect.top) {
        // Top hidden: scroll up to align.
        delta = blockRect.top - wrapperRect.top;
      }

      if (delta !== 0) {
        this.accordionsWrapper.scrollBy({ top: delta, behavior: 'smooth' });
      }
    }, 550);
  }
}

customElements.define('ia-set-info', IaSetInfo);

